import { Dropdown, Menu, Select, SelectProps } from 'antd';
import { defaultRegion2Langs } from './langs';
import { toUpperCase } from 'utils/toLowerCase';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';

interface RegionLangSelectProps extends Omit<SelectProps<string>, 'value' | 'onChange'> {
  region: General.CaselessRegion;
  value?: General.Language;
  onChange: (value: General.Language) => void;
}

export const RegionLangSelect = (props: RegionLangSelectProps) => {
  const { region, value, onChange, ...otherProps } = props;
  const { t } = useTranslate();

  const { priorityOptions, moreOptions, finalValue } = useMemo(() => {
    const { defaultValue, priority, more } =
      defaultRegion2Langs[toUpperCase(region)] || defaultRegion2Langs.GB;

    const priorityOptions = priority.map((item) => ({
      label: t(`langs.${item}`),
      value: item,
    }));
    const moreOptions = more.map((item) => ({
      label: t(`langs.${item}`),
      value: item,
    }));

    return {
      priorityOptions,
      moreOptions,
      finalValue: value || defaultValue,
    };
  }, [region, value, t]);

  return (
    <Dropdown
      disabled={otherProps.disabled}
      overlay={
        <Menu
          defaultOpenKeys={moreOptions.some(({ value }) => value === finalValue) ? ['more'] : []}
          selectedKeys={[finalValue]}
          onClick={({ key }) => onChange(key as any)}
        >
          {priorityOptions.map(({ value, label }) => (
            <Menu.Item key={value}>{label}</Menu.Item>
          ))}
          <Menu.SubMenu key="more" title={t('marketing.更多')}>
            {moreOptions.map(({ value, label }) => (
              <Menu.Item key={value}>{label}</Menu.Item>
            ))}
          </Menu.SubMenu>
        </Menu>
      }
    >
      <Select
        open={false}
        value={finalValue}
        options={[...priorityOptions, ...moreOptions]}
        {...otherProps}
      />
    </Dropdown>
  );
};
